import { Tab } from "bootstrap";
import { delay, initializePopovers } from "./utils";
import { setupDomainManagement } from "./Dashboard/domain_search";
import { setupStealerLogsNavigation } from "./Dashboard/stealer_logs";
import { setupNotificationToggle } from "./Dashboard/notification_toggle";
import { setupApiKeyGeneration } from "./Dashboard/api_keys";
import { setupChangeEmail } from "./Dashboard/change_email";
import { setupDomainVerification } from "./Dashboard/domain_verification";
// Dashboard internal functionality
export async function initializeDashboardInternal() {
    // Set the user's email and initial in the UI
    const userEmailElement = document.getHtmlElementById("userEmail");
    const userInitialElement = document.getHtmlElementById("userInitial");
    if (userEmailElement && userInitialElement) {
        // Initialize all popovers on page load
        initializePopovers();
        // Logout button functionality
        const logoutButton = document.getHtmlElementById("signOutButton");
        if (logoutButton) {
            logoutButton.addEventListener("click", () => {
                window.location.href = "/Dashboard/SignOutUser";
            });
        }
        // Enable URL hash updates when tabs are changed
        const tabLinks = document.queryHtmlElements('[data-bs-toggle="pill"]');
        if (tabLinks.length > 0) {
            for (const link of tabLinks) {
                link.addEventListener("shown.bs.tab", (event) => {
                    if (event.target && event.target instanceof HTMLAnchorElement && event.target.hash.startsWith("#")) {
                        // Update URL with the tab ID, but don't add history entry
                        window.history.replaceState(null, "", event.target.hash);
                    }
                });
            }
            // Activate the tab based on URL hash on page load
            if (window.location.hash) {
                const hash = window.location.hash;
                const tabToActivate = document.querySelector(`[href="${hash}"]`);
                if (tabToActivate) {
                    const tab = new Tab(tabToActivate);
                    tab.show();
                }
            }
        }
    }
    // Setup the domain verification functionality
    setupDomainVerification();
    // Setup stealer logs navigation from breaches table
    setupStealerLogsNavigation();
    // Set up notification toggle
    setupNotificationToggle();
    // Initialize domain management
    setupDomainManagement();
    // Setup API key generation functionality
    setupApiKeyGeneration();
    // Setup API key generation functionality
    setupChangeEmail();
    // Check for notification confirmation
    const urlParams = new URLSearchParams(window.location.search);
    const notificationConfirmed = urlParams.get("notification_confirmed");
    const notificationSuccess = document.getHtmlElementById("notificationSuccess");
    if (notificationConfirmed === "true" && notificationSuccess) {
        notificationSuccess.bootstrapShow();
        // Auto-hide the message after 10 seconds
        await delay(10000);
        notificationSuccess.bootstrapHide();
    }
}
